import React from 'react';
import unpick from '../../../utilities/unpick';

export default function Radio(props) {
  const { isValid } = props;
  const p = unpick(props, ['ariaLabel', 'isValid', 'value', 'valueWhenChecked']);

  const checked = props.value === props.valueWhenChecked;

  return (
    <input
      type="radio"
      {...p}
      aria-invalid={!isValid}
      aria-label={props.ariaLabel || 'Radio button'}
      checked={checked}
    />
  );
}

Radio.propTypes = {};
